import * as copilotControl from 'graphql/copilotControl.graphql'
import { api, REQUEST_TYPE } from 'store/api'
import { buildTxTrackingPatientsFilter } from 'components/CopilotControl/TxTrackingReport/txTrackingReportLogic'
import { ModuleTags } from './consts'

const SEARCH_PATIENTS_PAGE_SIZE = 12

export const TxTrackingReport = api.injectEndpoints({
  endpoints: build => ({
    fetchTxTrackingAggregation: build.query({
      query: ({ accountOwnerId, pastXDays }) => ({
        type: REQUEST_TYPE.GET,
        path: `/copilot/v1/practices/${accountOwnerId}/aggregations/txTracking`,
        // Amplify serializes a present-but-undefined key as `pastXDays=`, which the service
        // rejects, so the All period must leave the key out entirely.
        queryParams: pastXDays ? { pastXDays } : {}
      }),
      providesTags: [ModuleTags.TxTrackingAggregation]
    }),
    fetchTxTrackingPatients: build.infiniteQuery({
      infiniteQueryOptions: {
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages, lastPageParam) => (lastPage?.hasMore ? lastPageParam + 1 : undefined)
      },
      keepUnusedDataFor: 0,
      query: ({ queryArg, pageParam }) => {
        const { accountOwnerId, listType, categories = [], pastXDays } = queryArg

        return {
          type: REQUEST_TYPE.GRAPHQL,
          query: copilotControl.searchPatientSearchModels(copilotControl.fieldsByQuery.TxTrackingPatientsQuery),
          queryName: 'searchPatientSearchModels',
          variables: {
            limit: SEARCH_PATIENTS_PAGE_SIZE,
            from: pageParam * SEARCH_PATIENTS_PAGE_SIZE,
            sort: { direction: 'desc', field: 'lastTrackedScanDate' },
            filter: buildTxTrackingPatientsFilter({ accountOwnerId, listType, categories, pastXDays })
          }
        }
      },
      transformResponse: res => ({
        items: res?.searchPatientSearchModels?.items || [],
        hasMore: res?.searchPatientSearchModels?.items.length === SEARCH_PATIENTS_PAGE_SIZE
      })
    }),
    // The scan timeline item behind a row's scan icon, loaded on hover for the same tooltip Patient Copilot shows.
    fetchTrackedScanTimelineItem: build.query({
      query: ({ patientId, scanUniqueId }) => ({
        type: REQUEST_TYPE.GRAPHQL,
        query: copilotControl.fetchTrackedScanTimelineItem,
        variables: { patientId, scanUniqueId }
      }),
      transformResponse: res => {
        const timelineItem = res?.searchTimelineItems?.items?.[0]
        return timelineItem ? { ...timelineItem, payload: JSON.parse(timelineItem.payload || '{}') } : null
      }
    })
  })
})

export const {
  useFetchTxTrackingAggregationQuery,
  useFetchTxTrackingPatientsInfiniteQuery,
  useFetchTrackedScanTimelineItemQuery
} = TxTrackingReport
